import React from 'react';
import { cx } from './hooks';

export function PrimaryBtn({
  children,
  size = 'md',
  icon = true,
  className = '',
  tone = 'brand',
  ...rest
}) {
  const sz =
    size === 'sm' ? 'px-4 py-2 text-[12.5px]'
    : size === 'lg' ? 'px-7 py-4 text-[15px]'
    : 'px-5 py-3 text-[13.5px]';
  const tones = {
    brand: 'bg-ink-strong text-white hover:bg-black',
    amber: 'bg-brand text-ink-strong hover:bg-brand-hover',
    white: 'bg-white text-ink-strong ring-1 ring-line hover:ring-ink-strong',
  };
  return (
    <button
      type="button"
      {...rest}
      className={cx(
        'group inline-flex items-center gap-2 rounded-full font-bold tracking-tight transition shadow-sm',
        sz,
        tones[tone],
        className,
      )}
    >
      <span>{children}</span>
      {icon && (
        <span className="inline-grid place-items-center w-5 h-5 rounded-full bg-white/15 group-hover:translate-x-0.5 transition">
          <svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </span>
      )}
    </button>
  );
}

export function GhostBtn({ children, className = '', ...rest }) {
  return (
    <button
      type="button"
      {...rest}
      className={cx(
        'inline-flex items-center gap-2 text-[13px] font-bold text-ink-strong hover:text-black transition',
        className,
      )}
    >
      {children}
      <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <line x1="5" y1="12" x2="19" y2="12" />
        <polyline points="12 5 19 12 12 19" />
      </svg>
    </button>
  );
}

export function Eyebrow({ children, dot = true, tone = 'dark', dotClass = 'bg-brand' }) {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-2 text-[11px] font-bold tracking-[0.18em] uppercase',
        tone === 'dark' ? 'text-gray-500' : 'text-white/70',
      )}
    >
      {dot && <span className={cx('w-1.5 h-1.5 rounded-full', dotClass)} />}
      {children}
    </span>
  );
}

export function Chip({ children, tone = 'paper', size = 'sm', className = '' }) {
  const tones = {
    paper: 'bg-paper text-gray-700 ring-1 ring-line',
    ink: 'bg-ink-strong text-white',
    amber: 'bg-brand text-ink-strong',
    soft: 'bg-brand-soft text-amber-900 ring-1 ring-amber-200',
    glass: 'bg-white/95 backdrop-blur text-ink-strong ring-1 ring-black/5 shadow-sm',
    dark: 'bg-black/40 backdrop-blur text-white',
    emerald: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200',
    rose: 'bg-rose-50 text-rose-700 ring-1 ring-rose-200',
  };
  const sz =
    size === 'lg' ? 'px-3.5 py-1.5 text-[12.5px]'
    : size === 'xs' ? 'px-2 py-0.5 text-[10.5px]'
    : 'px-2.5 py-1 text-[11px]';
  return (
    <span className={cx('inline-flex items-center gap-1.5 rounded-full font-bold tracking-tight', tones[tone], sz, className)}>
      {children}
    </span>
  );
}
